import getEnvironmentVariables from '@/config/environment';
import { isServer } from '@/helpers/isServer';

declare global {
  interface Window {
    smartlook: any;
  }
}

// Reference: https://smartlook.github.io/docs/web#tracking-code
const smartlook = () => {
  const { ENABLE_SMARTLOOK, SMARTLOOK_PROJECT_KEY } = getEnvironmentVariables();
  // Converting to a string so we only have to deal with one type between client and server side
  if (String(ENABLE_SMARTLOOK) !== 'true' || isServer()) {
    return;
  }
  // Ignoring coverage because the !window.smartlook section can't be covered
  // since window.smartlook always needs to be a mocked function to be tested
  // istanbul ignore next
  if (!window.smartlook) {
    window.smartlook = (...args: any) => window.smartlook.api.push(args);
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    window.smartlook.api = [];
    script.async = true;
    script.type = 'text/javascript';
    script.src = 'https://rec.smartlook.com/recorder.js';
    script.onload = () => window.smartlook('init', SMARTLOOK_PROJECT_KEY);
    head.appendChild(script);
  } else {
    window.smartlook('init', SMARTLOOK_PROJECT_KEY);
  }
};
export default smartlook;
